import React from 'react';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import { useTranslation } from 'react-i18next';

interface IMobileTabsProps {
    handleTab: (event: React.SyntheticEvent, newValue: string) => void;
    tab: string;
    countOffer: {
        toDo: number;
        inProgress: number;
    };
    isLoading?: boolean;
}

export function OffersMobileTabs({ handleTab, tab, countOffer, isLoading = false }: IMobileTabsProps) {
    const { t } = useTranslation();

    const getCounter = (value: number) => (isLoading ? '–' : value);

    return (
        <Box>
            <TabContext value={tab}>
                <TabList variant="fullWidth" onChange={handleTab} aria-label="Offer management tabs" centered>
                    <Tab
                        className="text-uppercase"
                        label={t('influencer.offer_management.to_do', { counter: getCounter(countOffer?.toDo) })}
                        value="to-do"
                    />
                    <Tab
                        className="text-uppercase"
                        label={t('influencer.offer_management.in_progress', {
                            counter: getCounter(countOffer?.inProgress),
                        })}
                        value="in-progress"
                    />
                </TabList>
            </TabContext>
        </Box>
    );
}
